import CartService from "../models/CartService";
import PaymentDetailsAwbsServices from '../models/PaymentDetailsAwbsServices';
import AddServicesUnits from "../models/AddServicesUnits";
import { PaymentType } from "../models/PaymentType.enum";

export type AddServiceRawType = 'per_hawb' | 'per_hawb_exclude_import_service' | 'breakdown_hawb' | 'reicing' | 'bup_ld3' | 'bup_ld7' | 'bup_main_deck' | 'storage_fee' | 'customs_fee' | 'copa_comat' | 'nomination_fee' | 'certified_manifest_charge' | 'other' | 'comat' | 'perishable_storage' | 'cage_vault' | 'gha_adjust' | 'skid_exch';

const tariffNamesUnitTypes: any = {
  'per_hawb': 'Per HAWB',
  'per_hawb_exclude_import_service': 'Per HAWB',
  'breakdown_hawb': 'Per Kg',
  'reicing': 'Per Kg Dry Ice',
  'bup_ld3': 'Per Lower Deck LD3',
  'bup_ld7': 'Per Lower Deck LD7',
  'bup_20ft': 'Per Lower Deck 20ft',
  'bup_q7': 'Per Lower Deck Q7',
  'label_freight': 'Label Freight',
  'bup_main_deck': 'Per Deck Main',
  'import_service': 'Per MAWB',
  'return_fee': 'Per MAWB',
  'skid_exch': 'Per Exchange',
  'customs_fee': 'US Customs Fee',
  'comat': 'COMAT',
  'copa_comat': 'Copa COMAT',
  'nomination_fee': 'Nomination Fee',
  'certified_manifest_charge': 'Certified Manifest Charge'
};

const tariffNames: any = {
  'per_hawb': 'Pay by house bill',
  'per_hawb_exclude_import_service': 'Pay by house bill',
  'breakdown_hawb': 'Breakdown by House bill',
  'reicing': 'Reicing',
  'bup_ld3': 'BUP Breakdown - LD3',
  'bup_ld7': 'BUP Breakdown - LD7',
  'bup_main_deck': 'BUP Breakdown - Main Deck',
  'bup_20ft': 'BUP Breakdown - 20ft',
  'bup_q7': 'BUP Breakdown Q7',
  'label_freight': 'Label Freight',
  'storage_fee': 'Storage',
  'perishable_storage': 'Perishable Storage',
  'customs_fee': 'Customs Fee',
  'cage_vault': 'Cage-Vault Fee',
  'import_service': 'Import Fee',
  'return_fee': 'Shipment Return Fee',
  'other': 'Other',
  'gha_adjust': 'Adjustment',
  'convenience_fee': 'Convenience Fee',
  'skid_exch': 'Skid Exchange',
  'convenience_fee_credit_ach': 'Convenience fee ACH',
  'convenience_fee_credit_cart': 'Convenience fee CC',
  'comat': 'COMAT',
  'copa_comat': 'Copa COMAT',
  'nomination_fee': 'Nomination Fee',
  'certified_manifest_charge': 'Certified Manifest Charge'
};

const paymentNames: any = {
  'credit card payment': 'Trypod - Credit Card',
  'ach payment': 'Trypod - ACH payment',
  'credit account': 'Trypod - Credit Account',
  'Cargo Sprint': 'Cargo Sprint',
  'Pay Cargo': 'Pay Cargo',
  'Cash': 'Cash',
  'Cheque': 'Cheque',
  'not_paid': 'Not Paid',
  'partially_paid': 'Partially Paid',
  'overpayment': 'Overpayment',
  'underpayment': 'Underpayment',
  'adjustment': 'Adjustment'
};

const tariffNamesWithoutFeeACHAndCC: any = {
  'per_hawb': 'Pay by house bill',
  'per_hawb_exclude_import_service': 'Pay by house bill',
  'breakdown_hawb': 'Breakdown by House bill',
  'reicing': 'Reicing',
  'bup_ld3': 'BUP Breakdown - LD3',
  'bup_ld7': 'BUP Breakdown - LD7',
  'bup_main_deck': 'BUP Breakdown - Main Deck',
  'storage_fee': 'Storage',
  'perishable_storage': 'Perishable Storage',
  'customs_fee': 'Customs Fee',
  'cage_vault': 'Cage-Vault Fee',
  'bup_20ft': 'BUP Breakdown - 20ft',
  'bup_q7': 'BUP Breakdown Q7',
  'label_freight': 'Label Freight',
  'import_service': 'Import Fee',
  'return_fee': 'Shipment Return Fee',
  'other': 'Other',
  'gha_adjust': 'Adjustment',
  'convenience_fee': 'Convenience Fee',
  'skid_exch': 'Skid Exchange',
  'comat': 'COMAT',
  'copa_comat': 'Copa COMAT',
  'certified_manifest_charge': 'Certified Manifest Charge',
  'nomination_fee': 'Nomination Fee'
};

const tariffNamesOrder: any = {
  'per_hawb': 0,
  'per_hawb_exclude_import_service': 1,
  'breakdown_hawb': 2,
  'reicing': 3,
  'bup_ld3': 4,
  'bup_ld7': 5,
  'bup_main_deck': 6,
  'storage_fee': 7,
  'perishable_storage': 8,
  'cage_vault': 9,
  'other': 12,
  'gha_adjust': 11,
  'skid_exch': 10,
  'bup_20ft': 13,
  'bup_q7': 14,
  'label_freight': 15,
  'customs_fee': 16,
  'comat': 17,
  'copa_comat': 18,
  'certified_manifest_charge': 20,
  'nomination_fee': 19
};

function getAdditionalServicesNames(rawNames: Array<AddServiceRawType>): Array<[string, AddServiceRawType]> {

  const filteredServiceNames: Array<[string, AddServiceRawType]> = new Array(Object.keys(tariffNames).length);

  for (let i = 0; i < rawNames.length; i++) {

    if (tariffNames.hasOwnProperty(rawNames[i])) {
      filteredServiceNames[tariffNamesOrder[rawNames[i]]] = [tariffNames[rawNames[i]], rawNames[i]];
    }
  }

  return filteredServiceNames;
}

function getAdditionalServiceName(serviceRawName: string): string {
  return tariffNames[serviceRawName];
}

function getPaymentSourceName(serviceRawName: string): string {
  return paymentNames[serviceRawName];
}

function getAdditionalServiceUnitType(serviceRawName: string, params: AddServicesUnits): string {

  if (serviceRawName == 'storage_fee')
    return `Per ${params.storage_divisor}KG` + ` (MIN$${params.min_cost_usd || `${params.min_cost_per_day_usd} Per Day`})`;

  if (serviceRawName === 'perishable_storage' || serviceRawName === 'cage_vault')
    return `Per KG Per Day` + ` (MIN$${params.cost_per_kg_per_day_usd} Per Kg Per Day)`;

  if (serviceRawName === 'comat')
    return `COMAT`;

  if (serviceRawName === 'copa_comat')
    return `Copa COMAT`;
  return tariffNamesUnitTypes[serviceRawName];
}

function getAdditionalServiceUnitNumber(cartService: CartService | PaymentDetailsAwbsServices, weight: number): number | undefined {


  switch (cartService.type) {

    case 'per_hawb': return cartService.params.number_hawb;
    case 'per_hawb_exclude_import_service': return cartService.params.number_hawb;
    case 'breakdown_hawb': return weight;
    case 'reicing': return cartService.params.kg;
    case 'bup_ld3':
    case 'bup_ld7':
    case 'bup_main_deck':
    case 'bup_20ft':
    case 'bup_q7':
    case 'label_freight':
    case 'skid_exch': return cartService.params.units;
    case 'storage_fee': return cartService.calculations.days;
    case 'perishable_storage': return cartService.calculations.days;
    case 'customs_fee': return cartService.calculations.days;
    case 'cage_vault': return cartService.calculations.days;
    case 'comat':
    case 'copa_comat':
    case 'return_fee':
    case 'import_service':
    case 'certified_manifest_charge': return 1;
    default: return 0;
  }
}

function getAdditionalServiceCost(serviceRawName: string, params: AddServicesUnits): number {

  switch (serviceRawName) {

    case 'per_hawb': return params.cost_per_hawb_usd;
    case 'per_hawb_exclude_import_service': return params.cost_per_hawb_usd;
    case 'breakdown_hawb':
    case 'reicing': return params.cost_per_kg_usd;
    case 'bup_ld3':
    case 'bup_ld7':
    case 'bup_main_deck':
    case 'import_service':
    case 'return_fee':
    case 'bup_20ft':
    case 'bup_q7':
    case 'label_freight':
    case 'skid_exch': return params.cost_usd;
    case 'storage_fee': return params.cost_per_storage_unit_per_day_usd;
    case 'customs_fee': return params.cost_usd;
    case 'copa_comat':
    case 'comat':
    case 'certified_manifest_charge': return params.cost_usd;
    case 'perishable_storage': return params.cost_per_kg_per_day_usd;
    case 'cage_vault': return params.cost_per_kg_per_day_usd;
    default: return 0;
  }
}

function getAdditionalServiceDetails(service: CartService | PaymentDetailsAwbsServices, weight: number): string {

  let addServiceDetailsInfo: string = '';

  if (service.type === 'customs_fee') {
    addServiceDetailsInfo = 'Customs Exam Process Fees';
  }
  else if (service.type === 'comat') {
    addServiceDetailsInfo = 'COMAT';
  }
  else if (service.type === 'copa_comat') {
    addServiceDetailsInfo = 'Copa COMAT';
  }
  else if (service.type === 'nomination_fee') {
    addServiceDetailsInfo = 'Nomination Fee';
  }
  else if (service.type === 'certified_manifest_charge') {
    addServiceDetailsInfo = 'Certified Manifest Charge';
  }
  else if (service.type !== 'other' && service.type !== 'gha_adjust' && service.type !== 'convenience_fee' && service.type !== 'convenience_fee_ach' && service.type !== 'convenience_fee_credit_cart' && service.type !== 'customs_fee') {

    addServiceDetailsInfo += getAdditionalServiceUnitNumber(service, weight);
    addServiceDetailsInfo += ' @ ';
    addServiceDetailsInfo += getAdditionalServiceCost(service.type, service.tariff);
    addServiceDetailsInfo += ' ';
    addServiceDetailsInfo += getAdditionalServiceUnitType(service.type, service.tariff);

  } else {

    addServiceDetailsInfo += 'Flat charge';
  }

  return addServiceDetailsInfo;
}

export {
  getAdditionalServiceCost,
  getAdditionalServiceName,
  getAdditionalServicesNames,
  getAdditionalServiceDetails,
  getAdditionalServiceUnitType,
  getAdditionalServiceUnitNumber,
  getPaymentSourceName,
  tariffNames,
  tariffNamesWithoutFeeACHAndCC
}
